import { render, staticRenderFns } from "./ManualReadings.vue?vue&type=template&id=15a6e363&scoped=true&"
import script from "./ManualReadings.vue?vue&type=script&lang=js&"
export * from "./ManualReadings.vue?vue&type=script&lang=js&"
import style0 from "./ManualReadings.vue?vue&type=style&index=0&id=15a6e363&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a6e363",
  null
  
)

export default component.exports